"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.profession.list': '职业',
    'route.profession.create': '添加职业',
    'route.profession.edit': '编辑职业',
};
